
import { i18nHelper } from '@it-common/lbp_common'
import Loading from 'vux/src/components/loading/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'

import $ from 'jquery'
import util from '@/assets/js/util'
export default {
name: 'uploader',
components: {
Loading
},
directives: {
TransferDom
},
props: {
message: { type: String, default: '' },
field: { type: String, default: '' },
hidehtml: { type: Boolean, default: false },
uploadPDF: { type: Boolean, default: false }
},
data () {
return {
xhr: '',
id: '',
imgUrl: '',
ot: '',
loaded: '',
isPhoto: '1',
sectionID: '',
fileID: '',
startDate: '',
endDate: '',
showLoading: false
}
},
created () {
this.id = this.$route.query.id
this.vacation = this.$route.query.type_id ? this.$route.query.type_id : ''
this.abnormal = this.$route.query.abnormal_id ? this.$route.query.abnormal_id : ''

this.fileID = this.guid()
this.sectionID = this.guid()
},
mounted () {
i18nHelper.loadLanguagePack(4159)
},
methods: {
upload () {
$('#' + this.sectionID).fadeToggle()
},
UploadFileType () {
this.$refs[this.fileID].value = ''
this.$refs[this.fileID].dispatchEvent(new MouseEvent('click'))
},
guid () {
function S4 () {
return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1)
}
return S4() + S4() + '-' + S4() + '-' + S4() + '-' + S4() + '-' + S4() + S4() + S4()
},
/*
* 三个参数
* file：一个是文件(类型是图片格式)，
* w：一个是文件压缩的后宽度，宽度越小，字节越小
* objDiv：一个是容器或者回调函数
* photoCompress()
*/
photoCompress (file, w, objDiv) {
var self = this
var ready = new FileReader()
/*
开始读取指定的Blob对象或File对象中的内容.
当读取操作完成时,readyState属性的值会成为DONE,
如果设置了onloadend事件处理程序,则调用之.同时,
result属性中将包含一个data:
URL格式的字符串以表示所读取文件的内容.
*/
ready.readAsDataURL(file)
ready.onload = function () {
var re = this.result
self.canvasDataURL(re, w, objDiv)
}
},
canvasDataURL (path, obj, callback) {
var img = new Image()
img.src = path
img.onload = function () {
var that = this

var w = that.width,
h = that.height,
scale = w / h
w = obj.width || w
h = obj.height || w / scale
var quality = 0.7 

var canvas = document.createElement('canvas')
var ctx = canvas.getContext('2d')

var anw = document.createAttribute('width')
anw.nodeValue = w
var anh = document.createAttribute('height')
anh.nodeValue = h
canvas.setAttributeNode(anw)
canvas.setAttributeNode(anh)
ctx.drawImage(that, 0, 0, w, h)

if (obj.quality && obj.quality <= 1 && obj.quality > 0) {
quality = obj.quality
}

var base64 = canvas.toDataURL('image/jpeg', quality)

callback(base64)
}
},
/**
* 将以base64的图片url数据转换为Blob
* @param urlData
* 用url方式表示的base64图片数据
*/
convertBase64UrlToBlob (urlData) {
var arr = urlData.split(','),
mime = arr[0].match(/:(.*?);/)[1],
bstr = atob(arr[1]),
n = bstr.length,
u8arr = new Uint8Array(n)

while (n--) {
u8arr[n] = bstr.charCodeAt(n)
}

return new Blob([u8arr], { type: mime })
},

UpladFile () {
var self = this
try {
var sourceType = [
'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
'application/pdf',
'application/msword',
'image/jpeg',
'image/gif',
'image/png',
'image/jpg',
'image/bmp'
]

var notImageType = ['image/jpeg', 'image/gif', 'image/png', 'image/jpg', 'image/bmp']

var fileObj = document.getElementById(this.fileID).files 
var url =
process.env.API_HOST + '/api/v1.0/onboard/upload_material/' + this.id + '/' + this.field 


if (this.vacation) {
url =
process.env.API_HOST +
'/api/v1.0/attendance/upload_material/' +
this.vacation +
'/' +
this.field 
}

if (this.abnormal) {
url =
process.env.API_HOST +
'/api/v1.0/attendance/upload_image/' +
this.abnormal +
'/' +
this.field 
}

this.startDate = new Date().getTime()
for (var item = 0; item < fileObj.length; item++) {
this.showLoading = true
if (this.uploadPDF && sourceType.indexOf(fileObj[item].type) === -1) {
this.showLoading = false
this.$message.error('只支持上传gif/jpeg/png/doc/pdf等类型的文件。')
break
}


if (!this.uploadPDF && notImageType.indexOf(fileObj[item].type) === -1) {
this.showLoading = false
this.$message.error('只允许上传图片类型的文件。')
break
}

var form = new FormData() 

if (fileObj[item].size / 1024 > 15360) {
this.showLoading = false
this.$message.error('您上传的文件过大，请上传15M以下的文件，15M以上请拍照上传或压缩后上传。')
break
}

if (fileObj[item].size / 1024 > 1025 && notImageType.indexOf(fileObj[item].type) !== -1) {

self.photoCompress(
fileObj[item],
{
quality: 0.2
},
function (base64Codes) {
var bl = self.convertBase64UrlToBlob(base64Codes)
form.append('file', bl, 'file_' + Date.parse(new Date()) + '.jpg') 
self.xhr = new XMLHttpRequest() 
self.xhr.open('post', url, true) 

var _token1 = window.localStorage && window.localStorage.getItem('pre_token')
if (_token1) {
self.xhr.setRequestHeader('Authorization', 'Bearer ' + _token1)
}
self.xhr.onload = self.uploadComplete 
self.xhr.onerror = self.uploadFailed 

self.xhr.upload.onprogress = self.progressFunction 
self.xhr.upload.onloadstart = function () {

self.ot = new Date().getTime() 
self.oloaded = 0 
}

self.xhr.send(form) 
}
)
} else {

form.append('file', fileObj[item]) 
self.xhr = new XMLHttpRequest() 
self.xhr.open('post', url, true) 

var _token2 = window.localStorage && window.localStorage.getItem('pre_token')
if (_token2) {
self.xhr.setRequestHeader('Authorization', 'Bearer ' + _token2)
}
self.xhr.onload = self.uploadComplete 
self.xhr.onerror = self.uploadFailed 

self.xhr.upload.onprogress = self.progressFunction 
self.xhr.upload.onloadstart = function () {

self.ot = new Date().getTime() 
self.oloaded = 0 
}

self.xhr.send(form) 
}
}
} catch (e) {
this.$message.error('上传失败。')
this.showLoading = false
}
},


uploadComplete (evt) {

this.showLoading = false

if (evt && evt.target && evt.target.status === 401) {
util.handleUnauthorized()
return
}
var data = JSON.parse(evt.target.responseText)
this.startDate = new Date().getTime()
if (data.code === 0) {
this.$message.success('上传成功。')
if (data.field === 'identity_card_positive' || data.field === 'identity_card_back') {
this.$emit(
'success',
{
id: data.data.id,
src: data.data.pre_url,
url: data.data.filepath,
data: data,
extension: data.data.file_extension
},
data.field
)
} else {
this.$emit(
'success',
{
id: data.data.id,
src: data.data.pre_url,
url: data.data.filepath,
extension: data.data.file_extension
},
data.field
)
}
} else {
let errMessage = '上传失败。'
if (data.message) {
errMessage = data.message
}

this.$message.error(errMessage)
}
$(this.fileID + this.isPhoto).val('')
},

uploadFailed (evt) {

if (evt && evt.target && evt.target.status === 401) {
util.handleUnauthorized()
return
}
this.$message.error('上传失败。')
this.showLoading = false
},

cancleUploadFile () {
this.xhr.abort()
},

progressFunction (evt) {
this.showLoading = true

this.endDate = new Date().getTime()
if ((parseInt(this.endDate) - parseInt(this.startDate)) / 1000 > 60) {
this.$message.error('上传超时，请刷新界面，检查网络是否正常，如上传PDF文件大于10M，请压缩后上传。')
this.showLoading = false
return false
}

/*
var progressBar = document.getElementById("progressBar");
var percentageDiv = document.getElementById("percentage");

if (evt.lengthComputable) {            progressBar.max = evt.total;
progressBar.value = evt.loaded;
percentageDiv.innerHTML = Math.round(evt.loaded / evt.total * 100) + "%";
}
var time = document.getElementById("time");
var nt = new Date().getTime();
var pertime = (nt-self.ot)/1000; 
self.ot = new Date().getTime(); 
var perload = evt.loaded - self.oloaded; 
self.oloaded = evt.loaded;

var speed = perload/pertime;
var bspeed = speed;
var units = 'b/s';
if(speed/1024>1){
speed = speed/1024;
units = 'k/s';
}
if(speed/1024>1){
speed = speed/1024;
units = 'M/s';
}
speed = speed.toFixed(1);

var resttime = ((evt.total-evt.loaded)/bspeed).toFixed(1);
time.innerHTML = '，速度：'+speed+units+'，剩余时间：'+resttime+'s';
if(bspeed==0) time.innerHTML = '上传已取消';
*/
}
}
}



// WEBPACK FOOTER //
// ./src/components/onboard/uploader_single.vue